import { Order } from '../apiTypes';

export const getByCard = (paid: Order['paid']) => {
  if (!paid) {
    return 0;
  }
  if (typeof paid.byCard === 'number') {
    return paid.byCard;
  }
  return Object.values(paid.byCard).reduce((acc, value) => acc + value, 0);
};

export const getCash = (paid: Order['paid']) => {
  if (!paid) {
    return 0;
  }
  if (typeof paid.cash === 'number') {
    return paid.cash;
  }
  return Object.values(paid.cash).reduce((acc, value) => acc + value, 0);
};
